import React, { useEffect, useState } from 'react';
import { Button, Typography } from 'ui-kit';
import './MagicLinkPage.scss';

const RESEND_COOLDOWN_SECONDS = 60;

interface Props {
  email: string;
  // Resolves to true when the link was sent, so the cooldown starts again.
  onResend: () => Promise<boolean>;
  onChangeEmail?: () => void;
}

export default function CheckInbox({ email, onResend, onChangeEmail }: Props) {
  const [cooldown, setCooldown] = useState(RESEND_COOLDOWN_SECONDS);
  const [isResending, setIsResending] = useState(false);

  useEffect(() => {
    if (cooldown <= 0) {
      return undefined;
    }

    const timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
    return () => clearTimeout(timer);
  }, [cooldown]);

  const handleResend = () => {
    setIsResending(true);
    onResend()
      .then((isSent) => {
        if (isSent) {
          setCooldown(RESEND_COOLDOWN_SECONDS);
        }
      })
      .finally(() => setIsResending(false));
  };

  return (
    <div className="MagicLinkPage">
      <div className="MagicLinkPage-copy">
        <Typography variant="h5">Check your inbox</Typography>
        <Typography variant="body2" color="textGray">
          We sent a link to <b>{email}</b>.
          <br />
          It expires in 15 minutes and works once.
        </Typography>
      </div>
      <div className="MagicLinkPage-actions">
        <Button
          variant="outlined"
          fullWidth
          disabled={cooldown > 0}
          loading={isResending}
          onClick={handleResend}
        >
          {cooldown > 0 ? `Resend in ${cooldown}s` : 'Resend link'}
        </Button>
        {onChangeEmail ? (
          <Button variant="text" color="primary" size="small" fullWidth onClick={onChangeEmail}>
            Use a different email
          </Button>
        ) : (
          <Button to="/login/" variant="text" color="primary" size="small" fullWidth>
            Back to sign in
          </Button>
        )}
      </div>
    </div>
  );
}
